import { FC } from 'react';
import { Metric } from '@agilelab/plugin-wb-governance-common';
import { GovernanceTestOverviewMetricInfo } from './OverviewMetricInfoBox';

interface Props {
  metric: Metric;
}

export const GovernanceTestOverviewMetricSimple: FC<Props> = props => {
  return <GovernanceTestOverviewMetricInfo {...props} />;
};
